export enum UserType {
  customer = 'CUSTOMER',
  insurer = 'INSURER',
}

export interface SentEmailCodeValidateRequest {
  email: string;
  name?: string;
  cpfCnpj?: string;
  photoUrl?: string;
  matrixId: number;
  userId: number;
  userType: UserType;
  rentalCompany: boolean;
}

export interface SentEmailCodeValidateFormValues {
  email: string;
  matrixId: number;
}

export interface LinkUserMatrixRequest {
  cpfCnpj?: string;
  matrixId: number;
  userType: UserType;
  userId: number;
}

export interface UnlinkUserMatrixRequest {
  userId: number;
  userType: UserType;
  cpfCnpj?: string;
}
